import React, { useState, useRef } from 'react';
import { RotateCcw, Home, ArrowUp } from 'lucide-react';

const ThrowingGame = ({ config, onEnd }) => {
    const [ballPosition, setBallPosition] = useState({ x: 50, y: 80 });
    const [isDragging, setIsDragging] = useState(false);
    const [score, setScore] = useState(0);
    const [attempts, setAttempts] = useState(0);
    const [message, setMessage] = useState("Glissez vers le haut pour lancer !");

    const containerRef = useRef(null);

    const handleStart = () => setIsDragging(true);

    const handleEnd = (e) => {
        if (!isDragging) return;
        setIsDragging(false);

        setBallPosition({ x: 50, y: 10 });

        setTimeout(() => {
            const success = Math.random() > 0.3;
            if (success) {
                setScore(s => s + 10);
                setMessage("Bravo ! En plein dans le mille !");
            } else {
                setMessage("Oh, presque ! Réessayez.");
            }
            setAttempts(a => a + 1);

            setTimeout(() => {
                setBallPosition({ x: 50, y: 80 });
                if (attempts < 4) {
                    setMessage("À vous de jouer !");
                }
            }, 1500);

        }, 500);
    };

    if (attempts >= 5) {
        return (
            <div className="throwing-end-card">
                <h2 className="end-title">Partie terminée !</h2>
                <p className="end-score-text">Score : {score} / 50</p>
                <div className="end-actions">
                    <button onClick={() => window.location.reload()} className="btn-replay">
                        <RotateCcw /> Rejouer
                    </button>
                    <button onClick={() => onEnd(score)} className="btn-home">
                        <Home /> Accueil
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div
            ref={containerRef}
            className="throwing-container"
            style={{ background: config.bg || '#e2e8f0' }} // On garde le bg dynamique si précisé
            onMouseUp={handleEnd}
            onTouchEnd={handleEnd}
        >
            <h3 className="throwing-message">{message}</h3>
            <div className="throwing-attempts">Essai {attempts + 1} / 5</div>

            <div className="throwing-target">
                {config.target || "🎯"}
            </div>

            {ballPosition.y > 60 && (
                <div className="throwing-hint">
                    <ArrowUp size={48} />
                </div>
            )}

            <div
                onMouseDown={handleStart}
                onTouchStart={handleStart}
                className={`throwing-projectile ${isDragging ? 'dragging' : 'animating'}`}
                style={{
                    left: `${ballPosition.x}%`,
                    top: `${ballPosition.y}%`,
                }}
            >
                {config.projectile || "🥎"}
            </div>
        </div>
    );
};

export default ThrowingGame;